export interface SpendingAccountsState {
    coveragePeriodList: CoveragePeriodListState;
    spendingAccountList: SpendingAccountListState;
}

export interface CoveragePeriodListState {
    isFetching: boolean;
    membershipCoveragePeriods: MembershipCoveragePeriodSummary[];
    errorMessage?: string;
}

export interface SpendingAccountListState {
    isFetching: boolean;
    membershipSpendingAccounts: MembershipSpendingAccountList[];
    isSpendingAccountAllocationDialogOpen: boolean;
    isSavingAllocation: boolean;
    errorMessage?: string;
}

export interface MembershipSpendingAccountList {
    membershipId: number;
    spendingAccounts: SpendingAccountSummary[];
    paymentExclusion: PaymentExclusion;
}

export interface PaymentExclusion {
    reasonType: PaymentExclusionReasonType;
    reasonTypeName: string;
    createdDate: Date | string;
}

export interface SpendingAccountSummary {
    id: number;
    membershipId: number;
    coveragePeriodId: number;
    accountType: SpendingAccountType;
    packageName: string;

    planYear: PlanYearSummary;

    startDate: Date | string;
    lastActiveDate: Date | string;
    runoffEndDate: Date | string;
    spansEntirePlanYear: boolean;

    isPlaceholder: boolean;
    isActive: boolean;
    isInRunoff: boolean;
    isTerminated: boolean;
    isCancelled: boolean;
    isExpired: boolean;
    isUpcoming: boolean;
    hasAdjustments: boolean;

    allocationPercentage: number | null;
    isCoveragePeriodAllocated: boolean;
    allocationLockDate: Date | string;
    canChangeAllocation: boolean;

    balance: number;
    totalDepositedAmount: number;
    paidAmount: number;
    paymentExclusion: PaymentExclusion;
}

export interface PlanYearSummary {
    name: string;
    startDate: Date | string;
    endDate: Date | string;
    doesAllowWsa: boolean;
    wsaExpensePlanName: string;
    hsaExpensePlanName: string;
    allowsSavings: boolean;
}

export interface GeneralHealthBenefit {
    id: number;
    name: string;
    membershipId: number;
}

export interface AllocatableCoveragePeriod {
    coveragePeriodId: number;
    membershipId: number;
    startDate: Date | string;
    lastActiveDate: Date | string;
    hsaAllocation: number;
    wsaAllocation: number;
    tfsaAllocation: number;
    rrspAllocation: number;
    schoolJurisdictionName: string;
    hasSubmittedAllocation: boolean;
    allocationLockDate: Date | string;
    wsaExpensePlanName: string;
}

export interface MembershipCoveragePeriodSummary {
    membershipId: number;
    coveragePeriodSummaries: CoveragePeriodSummary[];
}

export interface CoveragePeriodSummary {
    id: number;
    membershipId: number;
    isCoveragePeriodAllocated: boolean;
    planYear: PlanYearSummary;
    wsaAllocation: number;
    hsaAllocation: number;
    rrspAllocation: number;
    tfsaAllocation: number;
    allocationLockDate: Date | string;
    allocationInitialLockDate: Date | string;
    allocationSetDate: Date | string;
    canChangeAllocation: boolean;
}

export enum SpendingAccountType {
    Unallocated = "Unallocated",
    HSA = "HSA",
    WSA = "WSA"
}

export enum SavingsAccountType {
    RRSP = "RRSP",
    TFSA = "TFSA"
}

export const SavingsAccountTypeDisplayNames = {
    [SavingsAccountType.RRSP]: "Registered Retirement Savings Plan",
    [SavingsAccountType.TFSA]: "Tax-Free Savings Account"
};

export enum PaymentExclusionReasonType {
    Overpayment = 1,
    Other = 2
}

export enum DepositStatus {
    DepositFailed = 2
}

export type SpendingAccountActivityTab = "claims" | "credits";
